// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module--list--mo8Tk","item":"styles-module--item--iHPUB"};